export const Logo = ({ light = true }) => (
  <a
    href="#top"
    data-testid="logo-link"
    onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: "smooth" }); }}
    className="flex items-center gap-3.5 group"
    aria-label="Elite Therapeutics — home"
  >
    <img
      src="/images/et-logo.png"
      alt="Elite Therapeutics logo"
      className="h-11 w-11 sm:h-12 sm:w-12 object-contain transition-transform duration-500 group-hover:rotate-[20deg]"
      data-testid="header-logo"
    />
    <span className="leading-none">
      <span className="block font-serif text-xl tracking-wide text-ivory">
        Ariane <em className="text-gold font-light italic">Kamba</em>
      </span>
      <span className="block font-mono text-[9px] tracking-[0.28em] text-mute uppercase mt-1">
        Elite Therapeutics
        <span className="hidden sm:inline">
          <span className="text-gold/80"> · </span>
          <em className="font-serif italic text-[11px] tracking-[0.08em] text-gold normal-case">Wellness in Motion</em>
        </span>
      </span>
    </span>
  </a>
);
